import { Injectable, signal } from '@angular/core';

import { delay, Observable, of, tap } from 'rxjs';

import { SupportFormApi } from './support-form-api.interface';
import {
  CreateRequestReq,
  CreateRequestRes,
  GetCoursesReq,
  GetFinancialCategoriesRes,
  GetLocationsRes,
  GetRequestIdHashRes,
  SaveRequestEncryptedData,
  SupportRequest,
} from '../../../models';
import { getCourses, getLocationsMock } from '../mocks/support-form.mock';
import { getRequestDetailsMock } from '../mocks/get-request-details.mock';
import { getRequestDetailsEncryptedDataMock } from '../mocks/save-request-encrypted-data.mock';
import { getFinancialCategoriesMock } from '../mocks/get-financial-categories.mock';

@Injectable()
export class SupportFormMockService implements SupportFormApi {
  isLoading = signal<boolean>(false);

  getFinancialRequestIdHash(): Observable<GetRequestIdHashRes> {
    return of({
      request: {
        requestIdHash: '937251f04cb8e76acccdb19d8bb27a20e59ee349d2f374fd705f1683c4e62f96',
      },
    }).pipe(delay(500));
  }

  getFinancialCategories(): Observable<GetFinancialCategoriesRes> {
    return of(getFinancialCategoriesMock()).pipe(delay(500));
  }

  createFinancialRequest(payload: CreateRequestReq): Observable<CreateRequestRes> {
    return of(getRequestDetailsMock(3)).pipe(delay(500));
  }

  saveRequestEncryptedData(payload: SaveRequestEncryptedData): Observable<SaveRequestEncryptedData> {
    return of(getRequestDetailsEncryptedDataMock(payload.requestIdHash)).pipe(delay(500));
  }

  getCourses(): Observable<GetCoursesReq> {
    return of({ courses: getCourses() }).pipe(
      delay(500),
      tap(() => this.isLoading.set(false)),
    );
  }

  getLocations(): Observable<GetLocationsRes> {
    return of({ itemsCount: 12, locations: getLocationsMock() }).pipe(
      delay(500),
      tap(() => this.isLoading.set(false)),
    );
  }

  sendRequest(payload: SupportRequest): Observable<unknown> {
    return of().pipe(
      delay(500),
      tap(() => this.isLoading.set(false)),
    );
  }
}
